import { createAsyncAction, createAction } from './creator';

export const SALES_TEAM_GET = 'SALES_TEAM_GET';
export const SALES_TEAM_GET_ALL = 'SALES_TEAM_GET_ALL';
export const SALES_TEAM_SET = 'SALES_TEAM_SET';
export const SALES_TEAM_SAVE = 'SALE_TEAM_SAVE';

export const getTeams = createAsyncAction(SALES_TEAM_GET);
export const getTeamList = createAsyncAction(SALES_TEAM_GET_ALL);
export const saveTeam = createAsyncAction(SALES_TEAM_SAVE);
export const setTeam = createAction(SALES_TEAM_SET);
